import React from 'react';
import { SvgIcon } from './svg-icon';

export const ArrowLeft2 = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M20.5 12.5L8.33 12.5L13.92 18.09L12.5 19.5L4.5 11.5L12.5 3.5L13.91 4.91L8.33 10.5L20.5 10.5L20.5 12.5Z" />
  </SvgIcon>
);
